import { LoadableLazy } from '@confluence/loadable';

export const MoveBlogModalLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MoveBlogModal" */ './MoveBlogModal.tsx'))
			.MoveBlogModal,
});
